import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { observer } from 'mobx-react-lite';

import { ThreeUpImageGroup } from './Components/ThreeUpImageGroup';
import { ThreeUpSectionBox } from './Components/ThreeUpSectionBox';
import { ThreeUpTextPortrait } from './Components/ThreeUpTextPortrait';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_ThreeUp>;
};

export const ThreeUpPortrait = observer(function ThreeUpPortrait({
  gridCard,
}: Props) {
  return (
    <ThreeUpSectionBox gridCard={gridCard}>
      <ThreeUpTextPortrait gridCard={gridCard} />
      <ThreeUpImageGroup gridCard={gridCard} />
    </ThreeUpSectionBox>
  );
});
